import { useSelector } from 'react-redux';
import config from 'config';
import { useAmplitudeExperiment } from '../../utils/ampli';
import { selectUser } from '../../reducers/user.selectors';
import { isTrialReportCardAttributeEligible } from './isTrialReportCardEligible';

/**
 * Whether the Trial Report Card UI should render for the current user: the
 * attribute check (in-trial B2C Bibliothek/kombi) gated by the
 * `trial-report-card` experiment flag. Recording (Phase 1) runs off the
 * attribute check alone, so a user entering the cohort immediately sees any
 * already-earned progress; this flag only gates visibility.
 *
 * The experiment is fetched only for attribute-eligible users (the key is
 * `undefined` otherwise), so non-B2C-trial users never trigger a fetch. Renders
 * nothing until the experiment resolves, avoiding a flash before eligibility is
 * known.
 */
export function useTrialReportCardEligibility(): boolean {
  const user = useSelector(selectUser);
  const attributeEligible = isTrialReportCardAttributeEligible(user);

  const { isReady, isEnabled } = useAmplitudeExperiment(
    user,
    attributeEligible ? config.amplitudeExperiments.trialReportCard : undefined,
  );

  return attributeEligible && isReady && isEnabled;
}
